export default __webpack_public_path__ + "ff5f4b3b5dd8c2bf5ac7d7faf074a1c1.png";